module.exports = __webpack_public_path__ + "static/img/08.1631599.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/artical/medical/08.png
// module id = LqdK
// module chunks = 1